<span
  class="toolbar"
  mat-dialog-title
  style="background-color: #3f4a49; color: #fff"
>
  <button mat-icon-button (click)="minimize()">
    <mat-icon style="color: #fff">minimize</mat-icon>
  </button>
  <button mat-icon-button (click)="close()">
    <mat-icon style="color: white">close</mat-icon>
  </button>
</span>
<mat-dialog-content>
  <h3 class="title">Radio La Senda Antigua</h3>

  <div class="radio-controls">
    @if(playState()==='loading'){
      <mat-spinner diameter="30"></mat-spinner>
    }@else {
      <button mat-icon-button (click)="togglePlay()">
      @if(playState()==='paused'){
      <mat-icon>play_arrow</mat-icon>
      }@else {
      <mat-icon>pause</mat-icon>
      }
      </button>
    }
    <div class="volume-controls" *ngIf="!isMobile()">
      <button mat-icon-button (click)="toggleMute()">
        @if (isVolumeUp()) {
        <mat-icon>volume_up</mat-icon>
        }@else {
        <mat-icon>volume_off</mat-icon>}
      </button>

      <mat-slider [max]="100" [min]="0" [step]="10">
        <input matSliderThumb [value]="volumeValue()" (valueChange)="volumeValue.set($event)" />
      </mat-slider>
    </div>
  </div>
  <div class="music-info">
    @if (!this.resetCurrentTrack() && currentTrack().title) {
    <span class="cc_streaminfo" #streaminfo>
      {{ currentTrack().title }} - {{ currentTrack().artist }} - {{ currentTrack().album }}
    </span>
    }
  </div>
</mat-dialog-content>
